const fired = new Set();
let loaded = false;

export function hasConsent() {
  return localStorage.getItem("cookie_consent") === "granted";
}

export function loadAnalytics(cfg) {
  if (loaded || !cfg || (!cfg.ga4_id && !cfg.gtm_id)) return;
  if (cfg.require_consent !== false && !hasConsent()) return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  if (cfg.gtm_id) {
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${cfg.gtm_id}`;
    document.head.appendChild(s);
  }
  if (cfg.ga4_id) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${cfg.ga4_id}`;
    document.head.appendChild(s);
    window.gtag("config", cfg.ga4_id, { anonymize_ip: true });
  }
  if (cfg.ads_conversion_id) window.gtag("config", cfg.ads_conversion_id);
}

// Never pass personal data (name, email, phone) in params.
export function track(event, params = {}, onceKey) {
  if (onceKey) {
    if (fired.has(onceKey)) return;
    fired.add(onceKey);
  }
  if (!loaded || !window.gtag) return;
  window.gtag("event", event, params);
}
